import { Translator } from 'Translator';
import PageContentBlock from 'components/PageContentBlock';
import Strong from 'components/Strong';
import CheckmarkIcon from 'components/icons/CheckmarkIcon';
import React from 'react';

const CSS = require('./UspBlock.module.scss');

function UspBlock() {
  return (
    <div className={CSS.Container}>
      <PageContentBlock className={CSS.UspBlock}>
        <div className={CSS.Titles}>
          <h2 className={CSS.Title}>
            {Translator.i18n(
              'USP.USPBlock.TitleStart',
              'Withlocals experiences',
            )}
            <div className={CSS.Highlighted}>
              {Translator.i18n('USP.USPBlock.TitleEnd', 'are always')}
            </div>
          </h2>
        </div>
        <div className={CSS.Paragraph}>
          <CheckmarkIcon className={CSS.Icon} />
          <div className={CSS.Texts}>
            <Strong className={CSS.SubTitle}>
              {Translator.i18n(
                'USP.USPBlock.USP1Title',
                'Private & personalized',
              )}
            </Strong>
            {Translator.i18n(
              'USP.USPBlock.USP1Text',
              'No strangers, just you. Fully customize your trip to your needs.',
            )}
          </div>
        </div>
        <div className={CSS.Paragraph}>
          <CheckmarkIcon className={CSS.Icon} />
          <div className={CSS.Texts}>
            <Strong className={CSS.SubTitle}>
              {Translator.i18n('USP.USPBlock.USP2Title', 'With a local expert')}
            </Strong>
            {Translator.i18n(
              'USP.USPBlock.USP2Text',
              'From historical facts to the most up-to-date health regulations.',
            )}
          </div>
        </div>
        <div className={CSS.Paragraph}>
          <CheckmarkIcon className={CSS.Icon} />
          <div className={CSS.Texts}>
            <Strong className={CSS.SubTitle}>
              {Translator.i18n('USP.USPBlock.USP3Title', 'Without the crowds')}
            </Strong>
            {Translator.i18n(
              'USP.USPBlock.USP3Text',
              'Experiences designed to take you away from the crowds towards authentic local spots.',
            )}
          </div>
        </div>
      </PageContentBlock>
    </div>
  );
}

export default UspBlock;
